import { withdrawAnnouncementApi } from '@eastcoal/api/trade/announcementOperation/withdrawAnnouncement'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { AnnouncementStatus } from '../../enums/AnnouncementStatus'

import { AnnouncementWithdrawButtonProps } from './interface'

export const AnnouncementWithdrawButton = ({
  uuid,
  record: { id, status }
}: AnnouncementWithdrawButtonProps) => {
  const { message } = useFeedback()
  const { reload } = useRemoteTableStore(state => pick(state, ['reload']))

  const handleConfirm = async () => {
    await withdrawAnnouncementApi({ announcementIds: [id as string] })
    message.success('撤回成功')
    reload()
  }

  return status === AnnouncementStatus.WAIT_PUBLISH ||
    status === AnnouncementStatus.PUBLISHED ? (
    <ConfirmButton
      warning
      message='确定撤回吗？'
      placement='leftBottom'
      type='link'
      uuid={uuid}
      onConfirm={handleConfirm}
    >
      撤回
    </ConfirmButton>
  ) : null
}
